export default "__VITE_ASSET__7a709b3b__"